import { render, staticRenderFns } from "./PoolsListNet.vue?vue&type=template&id=0157727e"
import script from "./PoolsListNet.vue?vue&type=script&lang=ts"
export * from "./PoolsListNet.vue?vue&type=script&lang=ts"
import style0 from "./PoolsListNet.vue?vue&type=style&index=0&id=0157727e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports